/**************************************************************************************************/
/*   File: /src/app/stores/actions/dossiers/actions.ts                                            */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday February 20th 2019                                                   */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu Apr 18 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Action } from '@ngrx/store';

import * as fromShared from '../../../shared';

/**
 * The dossiers action types enum
 */
export enum DossiersActionTypes {
    /**
     * The load dossies action
     */
    LOAD_DOSSIERS_SUMMARIES = '[Dossiers] Load all dossiers',
    /**
     * The load dossiers success action
     */
    LOAD_DOSSIERS_SUMMARIES_SUCCESS = '[Dossiers] Load all dossiers success',
    /**
     * The load dossiers fail action
     */
    LOAD_DOSSIERS_SUMMARIES_FAIL = '[Dossiers] Load all dossier fail',
}

/**
 * Action dispatched when user request all the dossier summaries
 */
export class LoadDossiersSummaries implements Action {
    /**
     * The type
     */
    readonly type = DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES;

    /**
     * The constructor of load dossier action
     */
    constructor() {
    }
}
/**
 * Action dispatched when load dossiers summaries has success
 */
export class LoadDossiersSummariesSuccess implements Action {
    /**
     * The type
     */
    readonly type = DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES_SUCCESS;

    /**
     * The constructor of load dossier success action
     * @param payload The payload is the dossiersSummaries
     */
    constructor(public payload: { dossiersSummaries: fromShared.models.DossierSummary[] }) {
    }
}
/**
 * Action dispatched when load dossier summaries fails
 */
export class LoadDossiersSummariesFail implements Action {
    /**
     * The type
     */
    readonly type = DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES_FAIL;

    /**
     * The constructor of load dossier summaries fail
     * @param payload The payload is the message
     */
    constructor(public payload: { message: fromShared.models.Message }) {
    }
}



/**
 * The dossier actions
 */
export type DossiersActions =
    LoadDossiersSummaries |
    LoadDossiersSummariesSuccess |
    LoadDossiersSummariesFail;
